import React from "react";

import { SidebarProvider } from "context/SidebarContext";
import { ChatProvider } from "context/ChatContext";
import { SignalRProvider } from "./SignalRContext";
import { BroadcastProvider } from "./BroadcastContext";

interface AppProviderProps {
  children: JSX.Element;
}

const AppProvider = ({ children }: AppProviderProps) => (
  <BroadcastProvider>
    <SignalRProvider>
      <ChatProvider>
        <SidebarProvider>{children}</SidebarProvider>
      </ChatProvider>
    </SignalRProvider>
  </BroadcastProvider>
);

export default AppProvider;
